import React, { FC, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import TableTab from "../components/tabs/table-tab";
import { FLOORS } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Category } from "../models/Category";
import columns from '../models/ColumnDefinitions/FloorColumn';
import { Filter } from "../models/Filter";
import { Lookup } from "../models/Lookup";
import LookupTypes from "../models/LookupTypes";
import searchColumns from '../models/search/FloorSearch';
import SiteSearch from "../models/search/SiteSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deleteFloor, getFloors } from "../services/floorService";
import { getSiteNamesWithPagination } from "../services/siteService";
import TableContextStateMonitor from "../contexts/table/TableContextStateMonitor";
import { getBuildingNamesWithPagination } from "../services/buildingService";
import BuildingSearch from "../models/search/BuildingSearch";
import { removeColumns } from "@/models/utilities/columnHelper";

interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void
    onFilterChange: (filter: Filter[]) => void
}

const FloorsTab: FC<Props> = ({ setBusy, categories, setCategories, onFilterChange }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.floors);
    const itemPath = '/access-control/hardware/floor/';

    const lookup: Lookup[] = [
        {
            name: LookupTypes.floorBySiteId,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        },
        {
            name: LookupTypes.building,
            values: [],
            dataMethod: getBuildingNamesWithPagination,
            searchAccessor: BuildingSearch.find(item => item.accessor === "name")?.searchOnName
        }
    ];

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteFloor(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        setCategories([{ ...categories[0], count: (categories[0]?.count ?? 1) - 1 }]);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = FLOORS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail) => void) => {
        setDetails(userLoginId, currentMenuDetail);
    }
    // <-- end context

    return (<TableContextProvider
        dataMethod={getFloors}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={removeColumns(columns, ['deviceName', 'actionName']) }
        searchDescriptor={removeColumns(searchColumns, ['deviceName', 'actionName'])}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        deleteMethod={onDelete}
        lookup={lookup}
        customDelete={{ fieldName: "isDefault", comparisonValue: false }} >
        <TableContextStateMonitor onFilterChange={onFilterChange} />
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath}
            cyName="floors" />
    </TableContextProvider >
    );
};

export default FloorsTab;
